import { render, staticRenderFns } from "./paishe.vue?vue&type=template&id=71f207d4&scoped=true"
import script from "./paishe.vue?vue&type=script&lang=js"
export * from "./paishe.vue?vue&type=script&lang=js"
import style0 from "./paishe.vue?vue&type=style&index=0&id=71f207d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f207d4",
  null
  
)

export default component.exports